import { observable, computed, action, runInAction } from 'mobx';
import AddressLookupResource from './addresslookup-resource';

export default class AddressLookupStore {
    addresses = observable.array();

    @computed get addressesArray() {
        let i = 0;
        return this.addresses.map(e => {
            return {
                id: i++,
                AgentName: e.AgentName,
                PropertyAddress: e.PropertyAddress,
                ListingId: e.ListingId,
                TransactionId: e.TransactionId,
            };
        });
    }

    constructor(appstore) {
        this.appStore = appstore;
        this.addressLookupResource = new AddressLookupResource();
        this.addresses;
    }

    @action.bound loadAddresses(query) {
        this.addressLookupResource.getAddresses(this.appStore.authStore.getAccessToken(), query).then(addressResult => {
            this.addresses.replace(addressResult['address-lookups']);
        });
    }
}



// WEBPACK FOOTER //
// ./src/files/addresslookup-store.js